import { ISite } from '../../../../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function toDataLayer(site: ISite): Record<string, any> {
  if (!site) return {};

  const brand = site.brand?.toLowerCase()?.replace(/ /g, '') || '';

  return {
    brand: brand,
    brand_id: brand,
    brand_locale: `${brand}|${site.region_code?.toLowerCase() || ''}`,
    brand_locale_space: `${brand} ${site.region_code?.toLowerCase() || ''}`,
    country_code: site.region_code?.toUpperCase() || '',
    currency_code: site.currency_code || '',
    language_code: site.language_code || '',
    locale: (site.locale_code || '').replace('-', '_'),
    platform: 'modernized/bifrost',
  };
}
